import { Fields as Campaign } from 'models/Campaign'
import { VariantOrCampaign } from 'models/CampaignVariant'
import React from 'react'
import EmailChannel from './EmailChannel'
import PushChannel from './PushChannel'

type PropsT = {
  config: VariantOrCampaign
  campaign: Campaign
  isEditable: boolean
  isControlVariant: boolean
}

const Channels: React.FC<PropsT> = ({ campaign, config }) => {
  return (
    <div>
      <EmailChannel campaign={campaign} config={config} />
      <PushChannel campaign={campaign} config={config} />
    </div>
  )
}

export default Channels
